import React from 'react'
import PropTypes from 'prop-types'
import CloseCircleIcon from '@offerzen/zenicon/CloseCircleIcon'
import { colors, fontSize } from '@offerzen/pinata'

import AccessibleIcon from '@/CandidateExperience/components/AccessibleIcon'

import { matchLabel } from '../constants'

import styles from './styles'

const NonMatchingList = ({ nonMatchingRequirements }) => {
  return (
    <ul className={styles.list}>
      <For each="nonMatchingRequirement" of={nonMatchingRequirements}>
        <li key={nonMatchingRequirement}>
          <AccessibleIcon icon={CloseCircleIcon} color={colors.mandy} className={styles.listMarker} size={fontSize.large} />
          {matchLabel[nonMatchingRequirement]}
        </li>
      </For>
    </ul>
  )
}

NonMatchingList.propTypes = {
  nonMatchingRequirements: PropTypes.arrayOf(PropTypes.string),
}

export default NonMatchingList
